import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import {
  CmpButton,
  CmpCheckboxField,
  CmpDatePicker,
  CmpSelectBox,

} from "../../../Component/Common/ToolBox/ToolBox";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { Typography } from "@mui/material";

const FilterNotificationModal = ({
  xOpen = false,
  fCloseModal,
  xTitle = "",
  filterState,
  setFilterState,
  load,
  vRdxDBLocation,
}) => {

  return (
    <Modal
      open={xOpen}
      onClose={fCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-pklst"
      >
        <GCTitleSticky title={xTitle} onClose={fCloseModal} />

        <div className="p-4">
          <Grid container spacing={4} className="align-items-center">
            <Grid item xs={6} className="bintransfer-data-date">
              <CmpDatePicker
                xLabelText={"From"}
                xValue={filterState?.dateFrom}
                xOnChange={(newValue) => {
                  setFilterState((prev) => ({ ...prev, dateFrom: newValue?.$d }));
                }}
                xName={"dateFrom"}
                xError={false}
                xErrorMessage={false}
              />
            </Grid>

            <Grid item xs={6} className="bintransfer-data-date">
              <CmpDatePicker
                xLabelText={"To"}
                xValue={filterState?.dateTo}
                xOnChange={(newValue) => {
                  setFilterState((prev) => ({ ...prev, dateTo: newValue?.$d }));
                }}
                xName={"dateTo"}
                xError={false}
                xErrorMessage={false}
              />
            </Grid>
            <Grid item xs={12}>
              <CmpSelectBox
                xLabelText="Location"
                xValue={filterState?.v_Loc}
                xOnChange={(e) => {
                setFilterState((prev) => ({ ...prev, v_Loc: e?.target?.value }))
                }}
                xName={"v_Loc"}
                xData={vRdxDBLocation}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={false}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography>Notification Type</Typography>
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={4}
                >
                  <CmpCheckboxField
                    xtabIndex={"1"}
                    xChecked={filterState?.v_InBound === "Y"}
                    xOnChange={(e) => {
                     setFilterState((prev) => ({
                        ...prev,
                        v_InBound: e.target.checked ? "Y" : "N",
                      }))
                    }}
                    xDisabled={false}
                    xName={"v_InBound"}
                    xNameField={"Inbound"}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={4}
                >
                  <CmpCheckboxField
                    xtabIndex={"2"}
                    xChecked={filterState?.v_Picking === "Y"}
                    xOnChange={(e) => {
                      setFilterState((prev) => ({
                        ...prev,
                        v_Picking: e.target.checked ? "Y" : "N",
                      }))
                    }}
                    xDisabled={false}
                    xName={"v_Picking"}
                    xNameField={"Picking"}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={4}
                >
                  <CmpCheckboxField
                    xtabIndex={"3"}
                    xChecked={filterState?.v_PutAway === "Y"}
                    xOnChange={(e) => {
                      setFilterState((prev) => ({
                        ...prev,
                        v_PutAway: e.target.checked ? "Y" : "N",
                      }))
                    }}
                    xDisabled={false}
                    xName={"v_PutAway"}
                    xNameField={"Put-Away"}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              // lg={2} md={4}
              xs={12}
              className="text-center"
            >
              <CmpButton
                xbtnName="Load"
                xOnClick={load}
                xVariant="contained"
                xSize="small"
                // xSendIcon={<FilterAltIcon />}
              />
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default FilterNotificationModal;
